import React, { useEffect, Component } from 'react';
import { X, AlertTriangle, Package, MapPin, CheckCircle, Tag, Check } from 'lucide-react';
import { Offer } from '../data/offers';
import { WA_NUMBER } from '../data/products';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
interface OfferModalProps {
  offer: Offer | null;
  onClose: () => void;
}
export function OfferModal({
  offer,
  onClose
}: OfferModalProps) {
  // Lock body scroll when open
  useEffect(() => {
    if (offer) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [offer]);
  // Close on ESC
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  if (!offer) return null;
  const discount = Math.round((offer.originalPrice - offer.offerPrice) / offer.originalPrice * 100);
  const isCombo = offer.includes.length > 0;
  const waLink = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(offer.waMessage)}`;
  return <div className="fixed inset-0 bg-black/90 z-[9999] overflow-y-auto p-[30px_20px] backdrop-blur-sm flex items-start justify-center" onClick={e => {
    if (e.target === e.currentTarget) onClose();
  }} data-id="element-295" data-mp="2udjjhaed8dtq">
      <div className="bg-dark-600 border-2 border-[#ff3b30]/50 rounded-xl max-w-[780px] w-full overflow-hidden relative m-auto animate-modal-in" data-id="element-296" data-mp="349wa1zem6bk9">
        <button onClick={onClose} className="absolute top-[15px] right-[20px] bg-transparent border-none text-white text-[2rem] cursor-pointer z-20 leading-none transition-colors duration-200 hover:text-[#ff3b30]" aria-label="Cerrar" data-id="element-297" data-mp="3e10qz4nuo6hq">
          <X size={32} data-id="element-298" data-mp="3mzm5moq7b1d8" />
        </button>

        <div className="w-full h-[320px] bg-white flex items-center justify-center overflow-hidden relative" data-id="element-299" data-mp="3i3ncyoxuax70">
          <div className="absolute top-4 left-4 bg-[#ff3b30] text-white text-sm font-black w-14 h-14 rounded-full flex items-center justify-center z-10 shadow-lg rotate-6" data-id="element-300" data-mp="2fqiqbpaxoy09">
            -{discount}%
          </div>
          <img src={offer.image} alt={offer.name} className={`w-full h-full object-contain p-[30px] ${offer.imageZoom ? 'scale-[1.25]' : ''}`} data-id="element-301" data-mp="2ookzis4tmwym" />
        </div>

        <div className="p-[35px]" data-id="element-302" data-mp="2yffow5dd6coa">
          <div className="inline-flex items-center gap-1.5 bg-[#ff3b30] text-white text-[0.75rem] font-extrabold py-1 px-3.5 rounded-sm tracking-[2px] uppercase mb-[15px]" data-id="element-303" data-mp="33f1x20ec52q8">
            <Tag className="w-3.5 h-3.5" data-id="element-304" data-mp="38c0rkk1wvboy" /> Oferta Imperdible
          </div>

          <h2 className="text-[1.6rem] font-black uppercase tracking-[2px] text-white mb-[15px]" data-id="element-305" data-mp="3cef7avaa9vc0">
            {offer.name}
          </h2>

          {isCombo && <div className="bg-[#1e1e1e] rounded-lg p-4 mb-5" data-id="element-306" data-mp="1i15yl5pkadut">
              <h4 className="text-[#ff3b30] text-[0.8rem] uppercase tracking-[2px] mb-3 font-bold flex items-center gap-2" data-id="element-307" data-mp="1i3s6j6gd6vdk">
                <Package className="w-4 h-4" data-id="element-308" data-mp="15rpztaepyqmg" /> Este combo incluye
              </h4>
              <ul className="space-y-2" data-id="element-309" data-mp="10sd3lz1yk777">
                {offer.includes.map((item, idx) => <li key={idx} className="flex items-start gap-2 text-[#ddd] text-[0.9rem] font-medium" data-id="element-310" data-mp="10q0ri2ivsr22" data-mpi={idx}>
                    <Check className="w-4 h-4 text-[#ff3b30] shrink-0 mt-0.5" data-id="element-311" data-mp="1tgiqarcko69o" />
                    <span data-id="element-312" data-mp="1oj0qprkg33ec">{item}</span>
                  </li>)}
              </ul>
            </div>}

          <div className="bg-[#ff3b30]/10 border-l-4 border-l-[#ff3b30] p-[18px_20px] mb-5 rounded-r" data-id="element-313" data-mp="1kej83vptmw55">
            <h4 className="text-[#ff3b30] text-[0.85rem] uppercase tracking-[2px] mb-2 font-bold flex items-center gap-2" data-id="element-314" data-mp="1fgzqqmxtu38z">
              <AlertTriangle className="w-4 h-4" data-id="element-315" data-mp="4244aesxuxhv" /> El Problema que Resuelve
            </h4>
            <p className="text-[#ccc] text-[0.92rem] leading-[1.7]" data-id="element-316" data-mp="44gvlikl6k7l">
              {offer.pain}
            </p>
          </div>

          <p className="text-[#aaa] leading-[1.8] text-[0.97rem] mb-[25px]" data-id="element-317" data-mp="1wq26btqzs8ok">
            {offer.description}
          </p>

          <p className="text-[0.85rem] uppercase tracking-[2px] text-[#666] mb-3 font-bold flex items-center gap-2" data-id="element-318" data-mp="1izf61x5l2aqd">
            <CheckCircle className="w-4 h-4 text-[#ff3b30]" data-id="element-319" data-mp="1n08woyaeu3my" /> BENEFICIOS CLAVE
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 mb-[25px]" data-id="element-320" data-mp="2aptf9g2niyvp">
            {offer.benefits.map((benefit, idx) => <div key={idx} className="flex items-start gap-2.5 bg-[#1e1e1e] p-3 rounded" data-id="element-321" data-mp="2fm0lzb2vgeep" data-mpi={idx}>
                <span className="text-[#ff3b30] font-black text-[1rem] flex-shrink-0 mt-px" data-id="element-322" data-mp="26mwzdx4hxgvg">
                  ✓
                </span>
                <span className="text-[#ccc] text-[0.85rem] leading-[1.5]" data-id="element-323" data-mp="q859pryqinpu">
                  {benefit}
                </span>
              </div>)}
          </div>

          <div className="flex items-center gap-5 mb-[25px] flex-wrap" data-id="element-324" data-mp="mq7r47ku9gak">
            <span className="text-[1rem] text-[#555] line-through" data-id="element-325" data-mp="iqguhn8ms5y4">
              ${offer.originalPrice.toLocaleString('es-UY')}
            </span>
            <span className="text-[2.5rem] font-black text-[#ff3b30]" data-id="element-326" data-mp="woxak4sdv8sx">
              ${offer.offerPrice.toLocaleString('es-UY')}
            </span>
            <span className="bg-[#ff3b30]/15 border border-[#ff3b30]/40 text-[#ff7a73] text-[0.85rem] font-extrabold py-1.5 px-4 rounded-full" data-id="element-327" data-mp="40i07vk75enx">
              AHORRÁS ${offer.savings.toLocaleString('es-UY')}
            </span>
          </div>

          <div className="bg-[#ff3b30]/10 border border-[#ff3b30]/25 rounded p-[14px_18px] mb-5 text-[0.88rem] text-[#ff3b30] font-semibold text-center flex items-center justify-center gap-2" data-id="element-328" data-mp="dsfa8yzgy0l2">
            <AlertTriangle className="w-4 h-4" data-id="element-329" data-mp="3hecx2nkkkbcr" /> Stock limitado · Esta oferta
            puede terminar en cualquier momento
          </div>

          <div className="bg-dark-500 border border-dark-300 rounded p-[15px_18px] mb-5 text-[0.85rem] text-[#999] space-y-2" data-id="element-330" data-mp="1gdpurbzvt5s3">
            <div className="flex items-start gap-2" data-id="element-331" data-mp="1lbzqbnpiq8e8">
              <Package className="w-4 h-4 mt-0.5 text-[#ff3b30] flex-shrink-0" data-id="element-332" data-mp="1laor8170potg" />
              <span data-id="element-333" data-mp="1q4b3hs99rqoq">
                <strong className="text-white" data-id="element-334" data-mp="1q5vnwp1vdt8v">Envío a domicilio:</strong> desde
                $190 pesos uruguayos, varía según tu zona
              </span>
            </div>
            <div className="flex items-start gap-2" data-id="element-335" data-mp="xgoozoyi71n3">
              <MapPin className="w-4 h-4 mt-0.5 text-[#ff3b30] flex-shrink-0" data-id="element-336" data-mp="12df52cab5x8i" />
              <span data-id="element-337" data-mp="16fii35cml9vw">
                <strong className="text-white" data-id="element-338" data-mp="16f0lu8pyqvnz">Pick Up:</strong> Malvín,
                Montevideo
              </span>
            </div>
          </div>

          <a href={waLink} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 bg-whatsapp text-white text-[1.05rem] font-extrabold py-[18px] px-[30px] rounded uppercase tracking-[1px] transition-all duration-300 w-full shadow-[0_6px_25px_rgba(37,211,102,0.3)] hover:bg-whatsappDark hover:scale-[1.02]" data-id="element-339" data-mp="1bcimzcxqo6lf">
            <WhatsAppIcon className="w-6 h-6" data-id="element-340" data-mp="2s0p5pma6fqvf" />
            Quiero Esta Oferta — Pedir por WhatsApp
          </a>
        </div>
      </div>
    </div>;
}